import P2PTransfer from "../../Component/WalletTransfer/P2P/P2PTransfer"

const P2PTransferPage = () => {
  return (
    <div className='page-body'>
      <P2PTransfer />
    </div>
  )
}

export default P2PTransferPage


